import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from '../../api/client'
import { keys } from '../../api/queries'
import type { PostDetail, ReelLanguage } from '../../api/types'
import { Select } from '../Select'
import { toast } from '../Toast'

const LABELS: Record<ReelLanguage, string> = {
  ru: 'Русский', en: 'English', other: 'Другой язык', unknown: 'Не определён', no_speech: 'Без речи',
}

export function LanguageBadge({ language = 'unknown' }: { language?: ReelLanguage }) {
  const label = language === 'ru' ? 'RU' : language === 'en' ? 'EN' : LABELS[language]
  return (
    <span className="inline-flex h-5 items-center rounded-md bg-black/70 px-1.5 text-[11px] leading-none font-medium text-white" title={`Язык: ${LABELS[language]}`}>
      {label}
    </span>
  )
}

export function ReelLanguageField({ post }: { post: PostDetail }) {
  const qc = useQueryClient()
  const change = useMutation({
    mutationFn: (language: 'ru' | 'en') => request(`/api/posts/${post.id}/language`, { method: 'PATCH', body: { language } }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: keys.post(post.id) })
      await qc.invalidateQueries({ queryKey: keys.feedAll })
      toast('Язык сохранён')
    },
    onError: () => toast('Не удалось изменить язык. Попробуйте ещё раз.', { error: true }),
  })
  const language = post.language ?? 'unknown'
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-muted">Язык:</span>
      {post.text_actions_allowed ? (
        <Select label="Изменить язык ролика" value={language} disabled={change.isPending} onChange={(e) => change.mutate(e.target.value as 'ru' | 'en')}>
          {language !== 'ru' && language !== 'en' && <option value={language} disabled>{LABELS[language]}</option>}
          <option value="ru">Русский</option>
          <option value="en">English</option>
        </Select>
      ) : <span>{LABELS[language]}</span>}
      {change.isPending && <span role="status" className="text-xs text-muted">Сохраняем…</span>}
    </div>
  )
}
